import "../../styles/TablesSTextArea.css";
import { useGame } from "../../GameContext";

type TextAreaProps = {
  sceneHeight: number;
};

const TextArea = ({ sceneHeight }: TextAreaProps) => {
  const { guessedWords } = useGame();

  return (
    <div
      className="tableS-Area"
      style={{ height: `${sceneHeight}vw` }}
    >
      <div className="tableS-subtitle">
        Найденные слова
      </div>

      <div className="tableS-textArea">
        {guessedWords.map((word, index) => (
          <div key={index}>{word}</div>
        ))}
      </div>
    </div>
  );
};
export default TextArea;
